"use client";

import { FolderTreeItem } from "@zapier/client";
import { FolderRenameModal } from "../FolderRenameModal";
import { FolderDeleteModal } from "../FolderDeleteModal";
import { FolderSharingModal } from "../FolderSharingModal/FolderSharingModal";
import { FolderCreationModal } from "../FolderCreationModal";
import { FolderModal, MoveFolderModal } from "@zapier/shared";

interface Props {
  currentModal: FolderModal | undefined;
  currentFolder: FolderTreeItem | undefined;
  setCurrentFolder: (folder?: FolderTreeItem | undefined) => void;
  setCurrentModal: (modal?: FolderModal | undefined) => void;
  optimisticUpdateEnabled?: boolean;
  closeModalAndClearParameters?: () => void;
}
export function FolderModals({
  currentModal,
  currentFolder,
  setCurrentModal,
  optimisticUpdateEnabled = true,
  setCurrentFolder,
  closeModalAndClearParameters,
}: Props) {
  const closeModal = () => {
    if (closeModalAndClearParameters) {
      closeModalAndClearParameters();
    } else {
      setCurrentModal();
      setCurrentFolder();
    }
  };

  return (
    <>
      <FolderRenameModal
        id={currentFolder?.id}
        initialValue={currentFolder?.name}
        isOpen={currentModal === FolderModal.Rename}
        setIsOpen={closeModal}
      />
      <FolderCreationModal
        isOpen={currentModal === FolderModal.Create}
        isShared={currentFolder?.isShared}
        isSharedSelectable={false}
        parentId={currentFolder?.id}
        setIsOpen={closeModal}
        targetParentFolderName={currentFolder?.name}
      />
      <FolderDeleteModal
        folderName={currentFolder?.name}
        id={currentFolder?.id}
        isOpen={currentModal === FolderModal.Delete}
        setIsOpen={closeModal}
      />
      <FolderSharingModal
        folder={currentFolder}
        isOpen={currentModal === FolderModal.Share}
        setIsOpen={closeModal}
      />
      <MoveFolderModal
        assetIds={[String(currentFolder?.id)]}
        assetsAreShared={currentFolder?.isShared}
        assetParentId={currentFolder?.parentId}
        assetTitle={currentFolder?.name}
        isOpen={currentModal === FolderModal.Move}
        optimisticUpdateEnabled={optimisticUpdateEnabled}
        setIsOpen={closeModal}
      />
    </>
  );
}
